(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6692],{

/***/ 39101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/vinted-feedback/index.tsx









function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-10-20",
      tag: "Vinted",
      title: "Vinted Guide: How to Handle Vinted Feedback Like a Pro",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you're a business owner, you should know that customer feedback is not always positive. In fact, most of the time, it's not! Customer feedback is what drives businesses. Without it, the sellers will not know how to improve their services or products to meet customer needs."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Just like any other marketplaces, customers are Vinted's lifeblood. Without buyers, there would be no reason to sell on Vinted, which is why customer feedback matters the most on the platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted Feedback is a way for customers to provide feedback on their experience with your business. This can be done through the Vinted app or email; both methods are easy and effective ways of gathering customer input."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It can be hard to know how to handle Vinted Feedback like a pro when it's coming from customers who just want their voices heard. But fear not! We're here to help! Here are insights on how Vinted Feedback works, why your customer feedback matters, and some tips on handling feedback from Vinted in the best way possible!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How Feedback Works on Vinted"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Do you ever go on Vinted and notice that a certain seller has a lot of negative feedback? You might be tempted to never buy from them, but they may have some good deals. The same goes for sellers with many positive reviews- they could be overpriced or not selling the best quality clothes."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted uses star-rating-based feedback in which buyers can leave either a 1-star or 5-star review depending on their shopping experience. This helps build trust among buyers and sellers on Vinted and makes the community more transparent."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you're thinking about buying something from someone with mixed reviews, here are Vinted star rating guidelines to help you further."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Star Rating Guidelines"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Your star rating is based on the average number of stars you received on your Vinted listing. Only feedback left by your buyers or through Vinted's automatic feedback affects your overall star rating."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To better understand this star-based feedback, here's whatthe meaning is behind each number rating:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "1-2 stars - Unhappy customers. Reasons behind this are the seller never shipped the items or the customer received items with defects or similar flaws that were not disclosed."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "3 stars - Neutral. Customers are not happy or unhappy with their purchase, but there are areas you can improve on."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "4-5 stars - Very good or great buyer's experience. The customer loves the item and is looking forward to their next purchase with you!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Another way to gather feedback is through Vinted automatic feedback. Not every buyer has time to leave a review after making a purchase. Some of them may have forgotten about it, allowing Vinted to leave feedback automatically on the seller's account."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted can leave either automatic positive feedback or automatic negative feedback. Here's how it works:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Automatic Positive Feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted automatically provides positive feedback to the seller if the buyer doesn't leave any of their own feedback four days after the order has been completed. If the buyer or the seller raises a complaint, no automatic positive feedback will be generated - only the buyer can leave feedback manually."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Automatic Negative Feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In comparison, Vinted can also give automatic negative feedback to buyers who manually cancel their orders the second time. Sellers who don't send the item on time, causing the system to cancel the order automatically, will also receive automatic negative feedback."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Leave Feedback on Vinted"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Leaving feedback for both buyers and sellers is crucial because it builds trust among Vinted members. Every feedback message counts, and when the same member leaves you more than one review, each feedback message will be taken into account."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can leave a Vinted feedback in two easy steps:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 1:"
        }), " Tap the \u201CLeave Feedback\u201D on your conversation screen. This button will only appear once the order is completed."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Step 2:"
        }), " Select the star rating, add a comment, and click the \u201CSubmit\u201D to post your feedback."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Edit Vinted Feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can edit or remove the feedback you left, including the automatic feedback from Vinted. Simply go to another member's profile page, click on their star rating, and find your review that you want to edit or remove."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Received an Unfair Feedback?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you've been selling for a while now, you might have already encountered an unhappy customer who may leave unfair feedback on your account. Feedback is essential in Vinted, as it helps build trust among the community. Thus, Vinted does not delete any feedback unless it violates Vinted's Community Standards."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While these unhappy campers may discourage potential buyers, here are two things you can do to turn the unfair feedback into a positive one:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Contact the member who left unfair feedback - Contact the buyer and try to resolve the problem. You may offer an additional discount for their next purchase, free shipping, or provide a partial refund. Depending on the case, talk with your buyer and try to find a friendly solution."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Respond to the unfair feedback - Not responding to negative feedback will make your potential buyers think twice about buying on your account. Respond to the unfair feedback and share your point of view. If it's something beyond your control, like a delay in shipping when you send it on time, you may say so, but do it professionally."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Received Inappropriate Feedback?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While receiving negative feedback is entirely normal, any inappropriate comments with harassment or offensive remarks can be reported directly on Vinted. The platform does not tolerate any feedback left that violates its community standards."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you received this kind of feedback, report it to Vinted immediately. To do this, simply follow the steps below:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap the (i) on your conversation screen with the member who left inappropriate feedback, then Report."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on the member who left harassing/offensive feedback and explain the situation in the description box."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted will take a look and will try to help resolve the problem."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "5 Reasons Why Customer Feedback Matters"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted Feedback is one of the many ways businesses measure customer satisfaction. It's not just what customers say but how they feel about their experience that really matters."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are the five reasons why your Vinted feedback matters and some valuable tips on handling your Vinted feedback like a pro:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Customer feedback helps in improving your listing."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "When creating a Vinted listing, sellers should consider their customers' needs to drive more sales. You may use your customer feedback to see which products are selling well and improve the listing of the products with low feedback."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "For example, a customer shared feedback regarding the wrong color of a product they purchased from your shop. You can improve the product images and take photos in a well-lit area to ensure that it will capture the natural color of your items. You may also indicate the item's color in the product description to set the customer's expectations."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Customer feedback helps you measure customer satisfaction."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Customer satisfaction and loyalty are crucial factors determining your selling performance on Vinted. A satisfied customer has many benefits, such as repeat purchases and good reviews that can entice more customers."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Therefore, there is no doubt that you want to ensure your customers are happy with your products on Vinted. The best way to determine if you meet their expectations is to get their opinions. Vinted uses star-rating-based feedback that lets you quickly estimate the level of satisfaction and consequently manage your selling goals."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Responding to feedback shows you value their opinions."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Buyers always appreciate it when you ask them if they are happy (or unhappy) with their purchases. Responding to all the feedback left from your buyers on Vinted, whether good or bad, shows you actually value their opinion and that you are here for them, not the other way around."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Responding to your customers' feedback as soon as possible also shows professionalism. It lets them show that you are willing to resolve their concerns or take note of their feedback and provide assurances that you're working on improving them. Putting your customers at the center of your business is the key to running a successful business."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Customer feedback helps you create the best customer experience."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Today's marketing is heavily based on people's experiences with products, services, and brands. They do not buy Apple products just because they are good. They want to demonstrate their status and affiliation to a particular group."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Therefore, sellers should focus on providing the best customer experience at every touchpoint and make more customers stay loyal to your brand! And naturally, the most effective way sellers can give an amazing experience is by asking them what they like about your product and what areas can be improved."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Gather their insights and focus on improving the opportunities to provide the best customer experience, which makes your customers crave more!"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Customer feedback gives you insights on what to do next."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Your feedback is one of the most reliable pieces of information you may use further in business decisions. Customer insights will help you understand customers and their needs more deeply. Thanks to that, you can easily find out where you should allocate your money, dive into the hottest trends, and generally make more sales."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Putting your customers in the center of your business and treating their feedback as valuable insights to help improve your business more is the key to winning more customers. Besides, you may use your Vinted Feedback to help source your next top-selling product, manage customer satisfaction, and ultimately - make more sales!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Thanks to customer feedback, you can ensure that your customers will stay with you, be loyal to your brand, and, consequently, spread positive word-of-mouth for you."
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Generate More Positive Reviews with OneShop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Remember that customer feedback is everywhere and the strongest force to attract customers is good reviews! As marketplace sellers, how can we ensure that happy customers actually take the step to post a review or give you high ratings? It all comes down to providing a stress-free shopping experience and good quality products."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Luckily, an automation service like OneShop offers an intelligent system and innovative features that allow resellers to reach out to more customers, boost the shop's visibility, and explore more ways to sell - without doing more work."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With OneShop, you can easily create a draft and cross list it to multiple marketplaces to make more sales outside Vinted. It automatically fills your listing preferences and delists once you sell to prevent selling a single item on various marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop now allows sellers to schedule a listing in advance (up to a week) and have it listed at the right time to reach out to more customers. OneShop provides the most polished automation experience for selling on marketplaces and is not only limited to automation."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Not only does it automate marketplace activities for you, but it also lets you order shipping supplies for your business and, at the same time, allows you to schedule package pickups. Plus, our seller community enables you to connect with other sellers and learn some of the best practices you can adapt to your business!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop is a great tool to help your reselling business succeed. Try it for yourself, avail our", /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          href: "https://tools.oneshop.com/signup",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: constants/* Marketing.TrialDuration */.F1.TrialDuration
          }), "-day free trial"]
        }), ' ', "with no upright payment needed, and experience how this tool can make a difference to your reselling venture."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/vinted-feedback.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Vinted Guide: How to Handle Vinted Feedback Like a Pro"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Information provided by customers, whether good or bad, will generally affect how businesses run. Here's how you can get the most out of Vinted feedback and utilize it to your advantage!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/vinted-feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/vinted-feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Vinted Guide: How to Handle Vinted Feedback Like a Pro"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Information provided by customers, whether good or bad, will generally affect how businesses run. Here's how you can get the most out of Vinted feedback and utilize it to your advantage!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-10-20T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-10-20T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Vinted"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 66776:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/vinted-feedback",
      function () {
        return __webpack_require__(39101);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(66776); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);